import ApiUtils from '@/utils/api/ApiUtils'
import Const from './Const'

// eslint-disable-next-line no-unused-vars
const StoreConst = Const.storeConst
const store = {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async userPartner_doBrowse ({ commit, state }, payload) {
      const val = {
        searchInfo: state.searchInfo,
        orderBy: state.orderBy,
        pagination: state.pagination
      }
      const res = await ApiUtils.postData({
        data: [{ api: 'C3101ProjectPartnerRequirementApplicationService.userPartner_doBrowse', input: val }]
      })
      commit('SET_ROWS', res[0].output.data)
      commit('SET_PAGINATION', res[0].output.pagination)
    },
    async userPartner_goToChatroom ({ commit, state }, payload) {
      return ApiUtils.postData({
        data: [{ api: 'C3101ProjectPartnerRequirementApplicationService.userPartner_goToChatroom', input: payload }]
      }).then((res) => {
        return res[0].output
      })
    }
  }
}

export default Const.getStore(store)
